<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/diw0oL/tc-custom/9781523095919.jpg?1740021352537" alt="This image is the cover for the book Why People Don't Believe You…"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Why People Don't Believe You…
      </h1>
      <p class="bookDescription body article font2">
        <p>For some, projecting confidence and credibility is second nature. For others, it seems like a foreign language they'll never learn – until now.Rob Jolles delivers down-to-earth solutions for anyone looking to enhance the most basic need of all; to be believed. He leverages his over 30 years of experience to equip readers with empowering and practical tools for achieving business and social success. <br/><br/>Jolles argues that credibility is as much about attitude as it is about aptitude. So-called “soft skills” like pitch, pace, and tone of voice, are actually some of the most crucial factors in determining how people perceive us. As he puts it, “it's not the words, it's the tune” that really makes us memorable and credible. <br/><br/>This book is about finding the necessary magic to help others believe you. It requires an unshakable belief in yourself, so Jolles starts there. With that as a solid foundation, you can move on to the specific tactics and practices that will make you credible and convincing. But these can be tough to practice in the face of the inevitable setbacks we all face, so he also offers advice on maintaining courage and confidence when doubt naturally creeps in. And he concludes with a discussion of sustaining your newfound credibility for the long haul. <br/><br/>There isn't a soul on earth who hasn't questioned themselves at some point. And most of us are just one or two brutal rejections away from questioning all that we are. Why People Don't Believe You helps readers cultivate a robust mental framework and a set of what Jolles calls “performance skills” to tackle these doubts. You are good enough –and after reading this stirring book, you'll be ready to make the world believe that as well. <br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rob Jolles, Brian Tracy
      </h2>
      
      <p class="authorDescription body article">Rob Jolles is a bestselling author and sought-after speaker who teaches, entertains, and inspires audiences worldwide.  His live programs in North America, Europe, Africa, and the Far East have  enabled him to amass a client list that reads like a Who’s Who of Fortune 500 companies, including Toyota, Disney, NASA, a dozen Universities, and over 50 financial institutions. He is the author of How to Change Minds, Customer Centered Selling, How to Run Seminars & Workshops and The Way of the Road Warrior.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5dea8f0a